var TabTrigger = function (_) { return null; };
export default TabTrigger;
